// crm namespace — Forms (Admin → CRM → Forms, design §E.4, Phase 2).
// Flat dotted keys, the same set in fr / en / es (i18n/__tests__/symmetry.test.js).
export default {
  fr: {
    "forms.consentSaved": "Texte de consentement enregistré",
    "forms.consentText": "Texte de consentement",
    "forms.copied": "Code d'intégration copié",
    "forms.copyEmbed": "Copier le code d'intégration",
    "forms.emailVerificationNote": "Les visiteurs confirment leur adresse e-mail avec un code à 6 chiffres avant que leur message ne vous parvienne.",
    "forms.fieldCode": "Code",
    "forms.fieldEmail": "E-mail",
    "forms.fieldIntake": "+ Champs d'accueil de la modalité",
    "forms.fieldIntakeUnavailable": "Aucune modalité avec un formulaire d'accueil pour l'instant",
    "forms.fieldMessage": "Message",
    "forms.fieldName": "Nom",
    "forms.fieldPhone": "Téléphone",
    "forms.fields": "Champs",
    "forms.loadFailed": "Impossible de charger le formulaire",
    "forms.preview": "Aperçu",
    "forms.previewCaption": "{host}/contact",
    "forms.previewChangeEmail": "Changer d'adresse",
    "forms.previewEmailError": "Vérifiez votre adresse e-mail",
    "forms.previewHeading": "Contactez-nous",
    "forms.previewResendCode": "Renvoyer le code",
    "forms.previewSend": "Envoyer le code",
    "forms.previewStep2Body": "Un code à 6 chiffres est envoyé à l'adresse ci-dessus pour la confirmer.",
    "forms.previewStep2Heading": "Étape 2 — confirmation par e-mail",
    "forms.previewSubmit": "Envoyer",
    "forms.previewTitle": "Aperçu du formulaire",
    "forms.required": "obligatoire",
    "forms.rotateKey": "Régénérer le lien",
    "forms.rotateKeyBody": "Le code d'intégration et le lien actuels cesseront de fonctionner. Mettez à jour votre site avec le nouveau code.",
    "forms.rotateKeyConfirm": "Régénérer",
    "forms.rotateKeyDone": "Lien régénéré",
    "forms.rotateKeyTitle": "Régénérer le lien du formulaire ?",
    "forms.saved": "Enregistré",
    "forms.snippet": "Extrait à coller sur votre site",
    "forms.submissions": "Réponses : {n} →",
    "forms.title": "Formulaires",
  },
  en: {
    "forms.consentSaved": "Consent text saved",
    "forms.consentText": "Consent text",
    "forms.copied": "Embed code copied",
    "forms.copyEmbed": "Copy embed code",
    "forms.emailVerificationNote": "Visitors confirm their email with a 6-digit code before their message reaches you.",
    "forms.fieldCode": "Code",
    "forms.fieldEmail": "Email",
    "forms.fieldIntake": "+ Modality intake fields",
    "forms.fieldIntakeUnavailable": "No modality has an intake form yet",
    "forms.fieldMessage": "Message",
    "forms.fieldName": "Name",
    "forms.fieldPhone": "Phone",
    "forms.fields": "Fields",
    "forms.loadFailed": "The form could not be read",
    "forms.preview": "Preview",
    "forms.previewCaption": "{host}/contact",
    "forms.previewChangeEmail": "Change email",
    "forms.previewEmailError": "Check your email address",
    "forms.previewHeading": "Get in touch",
    "forms.previewResendCode": "Resend code",
    "forms.previewSend": "Send code",
    "forms.previewStep2Body": "A 6-digit code is sent to the address above to confirm it.",
    "forms.previewStep2Heading": "Step 2 — confirm by email",
    "forms.previewSubmit": "Submit",
    "forms.previewTitle": "Form preview",
    "forms.required": "required",
    "forms.rotateKey": "Rotate link",
    "forms.rotateKeyBody": "The current embed code and link stop working. Update your site with the new code.",
    "forms.rotateKeyConfirm": "Rotate",
    "forms.rotateKeyDone": "Link rotated",
    "forms.rotateKeyTitle": "Rotate the form's link?",
    "forms.saved": "Saved",
    "forms.snippet": "Paste this into your site",
    "forms.submissions": "Submissions: {n} →",
    "forms.title": "Forms",
  },
  es: {
    "forms.consentSaved": "Texto de consentimiento guardado",
    "forms.consentText": "Texto de consentimiento",
    "forms.copied": "Código de inserción copiado",
    "forms.copyEmbed": "Copiar código de inserción",
    "forms.emailVerificationNote": "Los visitantes confirman su correo con un código de 6 dígitos antes de que su mensaje te llegue.",
    "forms.fieldCode": "Código",
    "forms.fieldEmail": "Correo",
    "forms.fieldIntake": "+ Campos de admisión de la modalidad",
    "forms.fieldIntakeUnavailable": "Ninguna modalidad tiene aún formulario de admisión",
    "forms.fieldMessage": "Mensaje",
    "forms.fieldName": "Nombre",
    "forms.fieldPhone": "Teléfono",
    "forms.fields": "Campos",
    "forms.loadFailed": "No se pudo leer el formulario",
    "forms.preview": "Vista previa",
    "forms.previewCaption": "{host}/contact",
    "forms.previewChangeEmail": "Cambiar correo",
    "forms.previewEmailError": "Revisa tu dirección de correo",
    "forms.previewHeading": "Ponte en contacto",
    "forms.previewResendCode": "Reenviar código",
    "forms.previewSend": "Enviar código",
    "forms.previewStep2Body": "Se envía un código de 6 dígitos a la dirección anterior para confirmarla.",
    "forms.previewStep2Heading": "Paso 2 — confirmación por correo",
    "forms.previewSubmit": "Enviar",
    "forms.previewTitle": "Vista previa del formulario",
    "forms.required": "obligatorio",
    "forms.rotateKey": "Rotar el enlace",
    "forms.rotateKeyBody": "El código de inserción y el enlace actuales dejarán de funcionar. Actualiza tu sitio con el nuevo código.",
    "forms.rotateKeyConfirm": "Rotar",
    "forms.rotateKeyDone": "Enlace rotado",
    "forms.rotateKeyTitle": "¿Rotar el enlace del formulario?",
    "forms.saved": "Guardado",
    "forms.snippet": "Pega esto en tu sitio",
    "forms.submissions": "Respuestas: {n} →",
    "forms.title": "Formularios",
  },
};
